var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1144,
    height: 964,
    viewBox: "0 0 1144 964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M893.938 547.368C842.055 608.332 779.696 655.147 712.87 683.303C646.044 711.458 577.003 720.004 512.399 708.118C447.795 696.233 389.804 664.315 344.015 615.441C298.226 566.568 266.18 502.384 250.967 429.076L637.325 250.678L893.938 547.368Z",
    fill: "#7B44E5",
    fillOpacity: 0.31
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_149",
    x: 0.967041,
    y: 0.678345,
    width: 1142.97,
    height: 962.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_1_149"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleShadow);
export default __webpack_public_path__ + "static/media/purpleShadow.c97848827e07ce0abc05cd26641153da.svg";
export { ForwardRef as ReactComponent };